export default __webpack_public_path__ + "static/cat2-f8165f8a3f1a96b59ef9e39bb819ca0d.jpg";